import { Button, EditorDialog, Spacer, Tooltip } from '@sparemin/blockhead';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteLayoutSegment } from 'redux/modules/embed/actions/layout';
import { createLayoutSegmentCountSelector } from 'redux/modules/embed/selectors';
import { Dispatch } from 'redux/types';
import { useIsInteractionDisabled } from '../state';
import useEditSceneModal from '../useEditSceneModal';
import useSaveScene from '../useSaveScene';
import EditSceneAdjustCropButton from './EditSceneAdjustCropButton';
import EditSceneBlurToggle from './EditSceneBlurToggle';
import EditSceneModalControlPanelCard from './EditSceneModalControlPanelCard';
import EditScenePresetSelector from './EditScenePresetSelector';

const EditSceneControlPanel: React.FC = () => {
  const { onHide, videoId, segmentId } = useEditSceneModal();
  const { isInteractionDisabled } = useIsInteractionDisabled();

  const { handleSaveScene } = useSaveScene();

  const dispatch = useDispatch<Dispatch>();

  const segmentCount = useSelector(createLayoutSegmentCountSelector(videoId));

  const handleDeleteScene = useCallback(() => {
    dispatch(deleteLayoutSegment(videoId, segmentId));
    onHide();
  }, [dispatch, onHide, segmentId, videoId]);

  return (
    <>
      <EditorDialog.ControlPaneTitle>
        Edit Scene
        <EditorDialog.CloseButton onClick={onHide} />
      </EditorDialog.ControlPaneTitle>
      <EditorDialog.ControlPaneBody>
        <EditSceneModalControlPanelCard>
          <Spacer orientation="vertical" space="large" align="center">
            <EditScenePresetSelector />
            <EditSceneBlurToggle />
          </Spacer>
        </EditSceneModalControlPanelCard>
        <EditSceneModalControlPanelCard>
          <EditSceneAdjustCropButton />
        </EditSceneModalControlPanelCard>
      </EditorDialog.ControlPaneBody>
      <EditorDialog.ControlPaneFooter>
        <Spacer orientation="horizontal" space="large">
          <Tooltip
            contents="You cannot delete the only scene in the video"
            isDisabled={segmentCount !== 1}
          >
            <Button
              color="danger"
              isDisabled={segmentCount === 1 || isInteractionDisabled}
              onPress={handleDeleteScene}
              variant="solid"
            >
              Delete
            </Button>
          </Tooltip>
          <Button
            color="primary"
            isDisabled={isInteractionDisabled}
            onPress={handleSaveScene}
            variant="solid"
            fluid
          >
            Save
          </Button>
        </Spacer>
      </EditorDialog.ControlPaneFooter>
    </>
  );
};

export default EditSceneControlPanel;
